<template>
    <info-container :header-text="spielerName" :width="950"
                    action="action" :valid-actions="[action]"
                    header-icon="">
        <template v-if="spieler" v-slot:headerIcon>
            <flag :iso="flags[spieler.info.nationalitaet]" :squared="false"
                  class="elevation-4 mr-4 d-inline-block"></flag>
        </template>
        <template v-if="spieler" v-slot:subTitle>
            <v-card-subtitle class="pt-2 pb-0 white">
                {{subTitle}}
            </v-card-subtitle>
            <v-card-subtitle class="pt-0 pb-2 white">
                <span v-if="team && saison.local.showByTeam">{{team}}</span>
                <span v-else>{{spieler.info.verein}}</span>
            </v-card-subtitle>
        </template>
        <div v-if="spieler" class="px-4 pt-3 pb-5">
            <div class="subtitle-2 pt-0 pb-1">Schnitte</div>
            <v-row>
                <v-col :class="[{'pr-1': $vuetify.breakpoint.xsOnly}]">
                    <spieler-performance-schnitt :spiele="spieler.countHeimSpiele()"
                        :schnitt="spieler.heimSchnitt()" location="Heim">
                    </spieler-performance-schnitt>
                </v-col>
                <v-col :class="[{'px-1': $vuetify.breakpoint.xsOnly}]">
                    <spieler-performance-schnitt :spiele="spieler.countGastSpiele()"
                         :schnitt="spieler.gastSchnitt()" location="Gast">
                    </spieler-performance-schnitt>
                </v-col>
                <v-col :class="[{'pl-1': $vuetify.breakpoint.xsOnly}]">
                    <spieler-performance-schnitt :spiele="spieler.countSpiele()"
                         :schnitt="spieler.totalSchnitt()" location="Total">
                    </spieler-performance-schnitt>
                </v-col>
            </v-row>
            <spieler-performance-list :spiele="spieler.spieleHeim" typeText="Heim"></spieler-performance-list>
            <spieler-performance-list :spiele="spieler.spieleGast" typeText="Gast" class="mb-15"></spieler-performance-list>
        </div>
    </info-container>
</template>

<script>
    import InfoContainer from "../../components/form/infoContainer";
    import {SpielerPerformance} from "../../services/data/spieler/spielerPerformance";
    import SpielerPerformanceSchnitt from "./spielerPerformanceSchnitt";
    import SpielerPerformanceList from "./spielerPerformanceList";

    export default {
        components: {
            SpielerPerformanceList,
            SpielerPerformanceSchnitt,
            InfoContainer},
        name: "spieler-performance",
        props: ['spielerId', 'saison', 'action', 'passNr', 'team', 'timeFrame'],
        computed: {
            flags(){ return this.$store.state.local.countryIso },
            spielerName(){ return this.spieler ? this.spieler.info.name : 'Test'},
            subTitle(){ return this.saison ? this.saison.getRegion() + ' / ' +
                        this.saison.getLigaFullName() + ' ' +
                        this.saison.sportJahr.replace('_', '/') : ''},
        },
        data: () => ({
            spieler: null,
            headers: [
                { text: 'Runde', value: 'infos.runde', sortable: false},
                { text: 'Heim', value: 'infos.heimTeam', sortable: false, align: 'right'},
                { text: '', value: 'gegen', sortable: false, align: 'center'},
                { text: 'Gast', value: 'infos.gastTeam', sortable: false, align: 'left'},
                { text: 'Quote', value: 'quote', sortable: false, align: 'center'},
                { text: 'DG/Bahn', value: 'bahn', sortable: false, align: 'center'},
                { text: 'SaP/MaP', value: 'punkte', sortable: false, align: 'center'},
                { text: 'Gegner', value: 'gegner', sortable: false, align: 'left'},
                { text: 'Ergebnis', value: 'result', sortable: false, align: 'center'},
            ]
        }),
        created(){
            console.log ("CREATE Spieler Performance", this.action );
            if ( this.spielerId ) {
                this.setSpielerPerformance()
            }
        },
        methods: {
            setSpielerPerformance(){
                this.spieler = new SpielerPerformance(this.spielerId, this.passNr, this.saison, this.team, this.timeFrame)
            }
        },
        watch: {
            spielerId(){
                console.log ("WATCH Spieler Performance SPIELER ID" );
                this.setSpielerPerformance();
            },
            team(){
                console.log ("WATCH Spieler Performance TEAM" );
                this.setSpielerPerformance();
            }
        }
    }
</script>

<style scoped>

</style>